import React, { useState, useEffect } from 'react'

import { PiSlidersLight } from "react-icons/pi";
import { TbCircleDotted } from "react-icons/tb";
import { BsQuestion } from "react-icons/bs";
import { IoNotifications } from "react-icons/io5";
import { LuLink } from "react-icons/lu";
import { FaUsers } from "react-icons/fa6";
import { PiClockCounterClockwiseFill } from "react-icons/pi";

// Reusable components --------------------------------------
import GeneralRules from './SettingPages/GeneralRules';
import ValidationRules from './SettingPages/ValidationRules';
import Notifications from './SettingPages/Notifications';
import Integrations from './SettingPages/Integrations';
import UserRoles from './SettingPages/UserRoles';
import AuditSettings from "./SettingPages/AuditSettings"
import { useSelect } from '../../../../../../services/commonServices';

// Main ccomponents starts here -----------------------------
const SettingsPage = () => {
    useEffect(() => {
        localStorage.removeItem("tdsUser")
    }, [])
    const tdsStore = useSelect("tds")

    const settingTabs = [
        { id: 1, label: "General Rules", icon: <PiSlidersLight className='icon rotate-icon' />, component: <GeneralRules /> },
        { id: 2, label: "Validation Rules", icon: <div className='two-icons' style={{ marginLeft: "9px", marginRight: "10px" }}><TbCircleDotted className='icon' /><BsQuestion className='icon-1' /></div>, component: <ValidationRules /> },
        { id: 3, label: "Notifications", icon: <IoNotifications className='icon' />, component: <Notifications /> },
        { id: 4, label: "Integrations", icon: <LuLink className='icon' />, component: <Integrations /> },
        { id: 5, label: "User Roles", icon: <FaUsers className='icon' />, component: <UserRoles /> },
        { id: 6, label: "Audit Settings", icon: <PiClockCounterClockwiseFill className='icon' />, component: <AuditSettings /> },
    ]

    const [activeSettingTab, setActiveSettingTab] = useState(1)
    // find active page based on menu id
    const activePage = settingTabs.find((p) => p.id === activeSettingTab)?.component || "";


    // Main ccomponents redering from here -------------------
    return (
        <div className='tds-settings-tab'>
            <h3 className='color-white font-weight-200'>Audit Settings & Compliance</h3>
            <h5 className='color-gray font-14 font-weight-200 mt-2'>Configure audit trail settings, data retention, and compliance controls</h5>

            <div className='settings-tabs mt-4'>
                {
                    settingTabs.map(item => {
                        return <button className={activeSettingTab == item.id ? 'settings-tab active' : 'settings-tab'} key={item.id} onClick={() => setActiveSettingTab(item.id)} >
                            {item.icon} {item.label}
                        </button>
                    })
                }


            </div>

            {/* Page Content */}
            <div className="mt-4">{activePage}</div>

        </div>
    )
}

export default SettingsPage